/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { getControlValue } from '@gh/core-ui';
import {
  CSMasterBusinessService,
  CSMasterFinderDialogConfig,
} from '../../resources/color-selection-master-finder-business.service';
import {
  CSMasterFinderListItem,
  getCSMasterFinderListItemId,
} from '../../resources/color-selection-master-finder-list-item.model';
import { ColorSelectionMasterFinderGridDefinition } from './color-selection-master-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-color-selection-master-finder-dialog',
  templateUrl: 'color-selection-master-finder-dialog.component.html',
  styleUrls: ['color-selection-master-finder-dialog.component.scss'],
  providers: [ColorSelectionMasterFinderGridDefinition],
})
export class CSMasterFinderDialogComponent
  extends AbstractFinderDialogComponent<CSMasterFinderDialogConfig, CSMasterFinderListItem>
  implements OnInit {

  getId = getCSMasterFinderListItemId;

  form: FormState<any>;

  defaultTitle = this.translations.get('lbl_find_color_selection_masters');

  constructor(public gridDefinition: ColorSelectionMasterFinderGridDefinition,
              private translations: TranslationService,
              formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>,
              private businessService: CSMasterBusinessService) {
    super(dialogRef);

    this.form = formStateBuilder.buildPlain({
      children: {
        name: void 0,
      },
    });
  }

  protected buildDataSource(): SlicedDataSource<CSMasterFinderListItem> {
    return this.businessService.findAllAsDataSource({
      searchString: getControlValue(this.form.group, 'name'),
      sourceOfficeId: this.input.sourceOfficeId,
    });
  }
}
